import type { FormEvent } from 'react';
import { Controller } from 'react-hook-form';
import { Button, Input, Label } from '@shared/components';
import type { FundingApproverForm } from '../hooks/useFundingApproverForm';

interface Props {
    form: FundingApproverForm;
}

const FIELD_ID = 'funding-approver-email';
const ERROR_ID = 'funding-approver-email-error';
const HINT_ID = 'funding-approver-email-hint';

export function FundingApproverField({ form }: Props) {
    const { control, submit, isSubmitting, locked } = form;

    const onSubmit = (event: FormEvent<HTMLFormElement>) => {
        void submit(event);
    };

    return (
        <form onSubmit={onSubmit} noValidate className="space-y-2">
            <div>
                <Label htmlFor={FIELD_ID} required>
                    Approver&apos;s email address
                </Label>
                <Controller
                    name="approverEmail"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <>
                            <Input
                                id={FIELD_ID}
                                type="email"
                                autoComplete="off"
                                value={field.value}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                error={!!error}
                                aria-invalid={!!error}
                                aria-describedby={error ? `${ERROR_ID} ${HINT_ID}` : HINT_ID}
                            />
                            <p id={ERROR_ID} role="alert" className="mt-1.5 text-xs text-mp-error">
                                {error?.message}
                            </p>
                        </>
                    )}
                />
                <p id={HINT_ID} className="mt-1.5 text-xs text-mp-muted">
                    The approver is emailed a code describing the excess and reads it back to you.
                </p>
            </div>

            <Button type="submit" size="sm" variant="outline" className="w-full" ariaDisabled={locked}>
                {isSubmitting ? 'Sending' : 'Send'}
            </Button>
        </form>
    );
}
